export const isCompleted = inspection => ["completed", "submitted"].includes(inspection.Status);
export const inspectionAge = inspection => isCompleted(inspection) ? inspection.CompletedAge : inspection.Age;

export const toggleSelection = (selected, inspection) => selected.some(item => item.PolicyNo === inspection.PolicyNo)
  ? selected.filter(item => item.PolicyNo !== inspection.PolicyNo)
  : [...selected, inspection];

export const ageGroup = age => age <= 10 ? "10" : age <= 20 ? "20" : age <= 30 ? "30"
  : age <= 60 ? "60" : age <= 90 ? "90" : age < 120 ? "119" : "120";
